import { ISwarmCreateBetCashierResponse, ISwarmDoBetTerminalResponse } from "src/common/swarm/models/response";
import { BetslipEventsEnum } from "src/constants/enums/betslipEvents";
import { IGoToGame } from "src/constants/interfaces";
import { IBookingTicketData } from "src/constants/interfaces/bet";
import Communicator from ".";
import { IVerificationResponse } from "src/constants/interfaces/verification";

export const emitFindBetByBookId = (bookId: number) => Communicator.send(BetslipEventsEnum.FindBetByBookId, +bookId);

export const emitBetProcessing = (data: { placeBetLoading: boolean }) =>
  Communicator.send(BetslipEventsEnum.BetProcessing, data);

export const emitBetPlaced = (betResponse: {
  data: ISwarmDoBetTerminalResponse | ISwarmCreateBetCashierResponse;
  verification?: IVerificationResponse | null;
  stakeAmount?: number
}) =>
  Communicator.send(BetslipEventsEnum.BetPlaced, betResponse);

export const emitBetBooked = (data: IBookingTicketData) => Communicator.send(BetslipEventsEnum.BetBooked, data);

export const emitProfitBoostInfo = (percent: number | null, stake: number | null) => Communicator.send(BetslipEventsEnum.ProfitBoost, { percent, stake });
export const emitGoToGame = (gameData: IGoToGame) => Communicator.send(BetslipEventsEnum.GoToGame, gameData);
